<template>
  <q-input
      v-bind="allAttrs"
      lazy-rules
      :type="type"
      :rules="requiredRules"
      :bg-color="bgColor"
      :clearable="clearable"
      :dense="dense || $isMobile"
      outlined
      hide-bottom-space
      @clear="$emit('clear')"
  >
    <template
        v-if="$slots.prepend"
        v-slot:prepend
    >
      <slot name="prepend" />
    </template>
    <template
        v-if="$slots.append"
        v-slot:append
    >
      <slot name="append" />
    </template>
    <slot />
  </q-input>
</template>

<script>
import Base from './Base'

export default {
  emits: ['clear'],
  extends: Base,
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    dense: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bgColor () {
      if (this.disable) {
        return 'neutral-5'
      }

      return this.$attrs['bg-color'] || 'white'
    },
  },
}
</script>
